import { defineStore } from 'pinia';
import api from '@/helpers/axiosConfig'
import useErrorStore from './error'

export default defineStore('campaign', {
  state: () => ({
    campaigns: [],
    activeCampaign: null,
    isLoading: false,
    retailers: [],
    campaignIsEnded: false,
  }),
  actions: {
    setCampaigns(data) {
      this.campaigns = data;
    },
    setActiveCampaign(data) {
      if (typeof data === 'string') {
        // Handle string ID case
        this.activeCampaign = {
          id: data,
          domain: data
        }
        return
      }
      
      // Handle object case - find existing campaign or use provided data
      const campaign = this.campaigns.find(c => c.id === data.id)
      this.activeCampaign = campaign || data
    },
    async fetchCampaigns() {
      try {
        this.isLoading = true
        const resp = await api.get(`/campaigns`)
        
        this.campaigns = resp.data.data
        // Sort campaigns by start date descending
        this.campaigns.sort((a, b) => new Date(b.startDate) - new Date(a.startDate))
        return resp.data.success
      } catch (err) {
        const errorStore = useErrorStore()
        errorStore.handleError(err)
        throw err
      } finally {
        this.isLoading = false
      }
    },
    async fetchCampaignByDomain(domain) {
      try {
        this.isLoading = true
        const resp = await api.get(`/campaigns/domain/${domain}`)
        
        if (resp.data.data[0]) {
          this.activeCampaign = resp.data.data[0]
          return resp.data.data[0]
        } else {
          return false
        }
      } catch (err) {
        const errorStore = useErrorStore()
        errorStore.handleError(err)
        throw err
      } finally {
        this.isLoading = false
      }
    },
    async fetchCampaignLimit() {
      try {
        this.isLoading = true
        const resp = await api.post(`/users/checkLimit`, { campaignId: this.activeCampaign.id })
        return resp.data.remainingLimit
      } catch (err) {
        const errorStore = useErrorStore()
        errorStore.handleError(err)
        throw err
      } finally {
        this.isLoading = false
      }
    },
    async fetchRetailers() {
      try {
        this.isLoading = true
        const resp = await api.get(`/campaigns/${this.activeCampaign.id}/retailer`)
        
        this.retailers = resp.data.data
        return resp.data.success
      } catch (err) {
        const errorStore = useErrorStore()
        errorStore.handleError(err)
        throw err
      } finally {
        this.isLoading = false
      }
    },
  },
  getters: {
    getActiveCampaign() {
      return this.activeCampaign;
    }
  }
});
